import React from "react";

function PageNavigation({ 
    sidebarVisible,
    currentPageIndex,
    pages,
    navigateToPage
}) {
    if (!sidebarVisible) {
        return null;
    }

    return (
        <div className={`floating-page-nav modern ${!sidebarVisible ? 'hidden' : ''}`}>
            <div className="page-nav-header-modern">
                <div className="page-nav-title">
                    <i className="fas fa-book-open"></i>
                    <span>Pages</span>
                </div>
                <div className="page-counter-modern">
                    <span className="current-page">{currentPageIndex + 1}</span>
                    <span className="page-divider">/</span>
                    <span className="total-pages">{pages.length}</span>
                </div>
            </div>
            
            <div className="page-nav-controls-modern">
                <button 
                    className="nav-btn-modern prev"
                    onClick={() => navigateToPage(currentPageIndex - 1)}
                    disabled={currentPageIndex === 0}
                    title="Previous page"
                    aria-label="Previous page"
                >
                    <i className="fas fa-chevron-up"></i>
                </button>
                
                <button 
                    className="nav-btn-modern next"
                    onClick={() => navigateToPage(currentPageIndex + 1)}
                    disabled={currentPageIndex === pages.length - 1}
                    title="Next page"
                    aria-label="Next page"
                >
                    <i className="fas fa-chevron-down"></i>
                </button>
            </div>
            
            <div className="page-grid-modern">
                {pages.map((page, index) => (
                    <button
                        key={page.id}
                        className={`page-card-modern ${index === currentPageIndex ? 'active' : ''}`}
                        onClick={() => navigateToPage(index)}
                        title={`Page ${index + 1}`}
                        aria-label={`Go to page ${index + 1}`}
                    >
                        <div className="page-card-content">
                            <span className="page-number-label">{index + 1}</span>
                            {page.strokes.length > 0 && (
                                <div className="content-indicator">
                                    <i className="fas fa-circle"></i>
                                </div>
                            )}
                        </div>
                        {index === currentPageIndex && (
                            <div className="active-indicator"></div>
                        )}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default PageNavigation;
